import React, { useEffect, useState } from "react"
import axios from "axios"
import { useUI } from '../contexts/UIContext'

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"
const STATUS_COR: any = {
  atrasada:   { bg:"#450a0a", border:"#dc2626", text:"#f87171", label:"⚠️ Atrasada" },
  proxima:    { bg:"#451a03", border:"#f59e0b", text:"#fbbf24", label:"⏰ Próxima" },
  programada: { bg:"#0c2a4a", border:"#0ea5e9", text:"#38bdf8", label:"📅 Programada" },
  concluida:  { bg:"#14532d", border:"#22c55e", text:"#4ade80", label:"✅ Concluída" },
}
const UNIDADES = ["un","L","ml","kg","g","m","par","jogo","cx"]

const fmtData = (d:any) => {
  if (!d) return "—"
  const s = d.includes("T") ? d.split("T")[0] : d
  const [ano,mes,dia] = s.split("-")
  return `${dia}/${mes}/${ano}`
}
const fmt = (n:any) => n ? `R$ ${parseFloat(n).toLocaleString("pt-BR",{minimumFractionDigits:2})}` : "—"

export default function Manutencao() {
  const [tab, setTab]               = useState<"lista"|"nova">("lista")
  const [hodometroAtivo, setHodometroAtivo] = useState<any>(null)
  const [abaAtiva, setAbaAtiva]     = useState<"manutencoes"|"historico"|"pecas"|"fornecedores">("manutencoes")
  const [manutencoes, setManut]     = useState<any[]>([])
  const [historico, setHistorico]   = useState<any[]>([])
  const [pecas, setPecas]             = useState<any[]>([])
  const [fornecedores, setFornecedores] = useState<any[]>([])
  const [tipos, setTipos]             = useState<any[]>([])
  const [formPeca, setFormPeca]       = useState<any>({nome:'',tipos_ativo_ids:[],descricao:''})
  const [formForn, setFormForn]       = useState<any>({nome:'',nome_fantasia:'',telefone:'',email:'',cnpj:'',cep:'',logradouro:'',numero:'',bairro:'',cidade:'',estado:'',tipo:'oficina'})
  const [consultandoCNPJ, setConsultandoCNPJ] = useState(false)
  const [consultandoCEP, setConsultandoCEP]   = useState(false)
  const [editPeca, setEditPeca]       = useState<any>(null)
  const [editForn, setEditForn]       = useState<any>(null)
  const [salvendoPeca, setSalvendoPeca] = useState(false)
  const [salvandoConcluir, setSalvandoConcluir] = useState(false)
  const [salvendoForn, setSalvendoForn] = useState(false)
  const [filtroPecaTipo, setFiltroPecaTipo] = useState('')
  const [tipoVeiculoSel, setTipoVeiculoSel]   = useState('')
  const [pecasFiltradas, setPecasFiltradas]   = useState<any[]>([])
  const [tiposVeiculo, setTiposVeiculo]       = useState<any[]>([])
  const [ativos, setAtivos]         = useState<any[]>([])
  const [resumo, setResumo]         = useState<any>({})
  const { toast, confirm } = useUI()
  const [loading, setLoading]       = useState(true)
  const [filtro, setFiltro]         = useState("todas")
  const [ativoFiltro, setAtivoFiltro] = useState("")
  const [salvando, setSalvando]     = useState(false)
  const [editandoId, setEditandoId] = useState<string|null>(null)
  const [emailExtra, setEmailExtra] = useState("")
  const [modalConcluir, setModalConcluir] = useState<any>(null)
  const [buscaHistorico, setBuscaHistorico] = useState("")
  const [historicoExpandido, setHistoricoExpandido] = useState<string | null>(null)
  const [modalAuditoria, setModalAuditoria] = useState<any>(null)
  const [auditoriaItens, setAuditoriaItens] = useState<any[]>([])
  const [carregandoAuditoria, setCarregandoAuditoria] = useState(false)
  const [nfeFile, setNfeFile] = useState<File|null>(null)
  const [cotacaoFile, setCotacaoFile] = useState<File|null>(null)
  const [formConcluir, setFormConcluir] = useState<any>({hodometro_realizado:'',
    data_realizada:"", fornecedor_id:"", nf_numero:"", observacoes:"",
    itens:[{tipo_id:"",descricao:"",quantidade:"1",unidade:"un",custo_unitario:""}]
  })
  const [form, setForm] = useState<any>({
    ativo_id:"", intervalo_km:"", intervalo_dias:"", data_proxima:"",
    alerta_km_antes:"", alerta_dias_antes:"", hodometro_proximo:"",
    notif_email:true, emails_notif:[], observacoes:"",
    itens:[{tipo_id:"",descricao:"",quantidade:"1",unidade:"un"}]
  })

  useEffect(() => { carregar() }, [])



  const carregar = async () => {
    setLoading(true)
    try {
      const [m,t,a,r,f,h,pc,fn,tv] = await Promise.all([
        axios.get(`${API}/manutencoes`),
        axios.get(`${API}/manutencoes/tipos`),
        axios.get(`${API}/ativos`),
        axios.get(`${API}/manutencoes/resumo`),
        axios.get(`${API}/fornecedores`),
        axios.get(`${API}/manutencoes/historico`),
        axios.get(`${API}/pecas-manutencao`),
        axios.get(`${API}/fornecedores`),
        axios.get(`${API}/tipo-ativo`), // tiposVeiculo
      ])
      setManut(m.data); setTipos(t.data); setAtivos(a.data)
      setResumo(r.data); setFornecedores(f.data); setHistorico(h.data)
      setPecas(pc.data); setFornecedores(fn.data); setTiposVeiculo(tv.data)
    } catch {} finally { setLoading(false) }
  }

  const addItem = () => setForm((f:any) => ({...f,itens:[...f.itens,{tipo_id:"",descricao:"",quantidade:"1",unidade:"un"}]}))
  const remItem = (i:number) => setForm((f:any) => ({...f,itens:f.itens.filter((_:any,j:number)=>j!==i)}))
  const updItem = (i:number,k:string,v:string) => setForm((f:any) => ({...f,itens:f.itens.map((x:any,j:number)=>j===i?{...x,[k]:v}:x)}))
  const addItemC = () => setFormConcluir((f:any) => ({...f,itens:[...f.itens,{tipo_id:"",descricao:"",quantidade:"1",unidade:"un",custo_unitario:""}]}))
  const remItemC = (i:number) => setFormConcluir((f:any) => ({...f,itens:f.itens.filter((_:any,j:number)=>j!==i)}))
  const updItemC = (i:number,k:string,v:string) => setFormConcluir((f:any) => ({...f,itens:f.itens.map((x:any,j:number)=>j===i?{...x,[k]:v}:x)}))

  const editarManut = async (m:any) => {
    setEditandoId(m.id)
    // Carregar itens primeiro
    let itensCarregados = [{tipo_id:"",descricao:"",quantidade:"1",unidade:"un"}]
    try {
      const itensR = await axios.get(`${API}/manutencoes/${m.id}/itens`)
      if (itensR.data?.length > 0) {
        itensCarregados = itensR.data.map((it:any)=>({
          tipo_id: it.tipo_id||"",
          descricao: it.descricao||"",
          quantidade: String(it.quantidade||"1"),
          unidade: it.unidade||"un"
        }))
      }
    } catch {}

    setForm({ ativo_id:m.ativo_id||"", intervalo_km:m.intervalo_km||"", intervalo_dias:m.intervalo_dias||"",
      data_proxima:m.data_proxima?m.data_proxima.split("T")[0]:"", hodometro_proximo:m.hodometro_proximo||"", alerta_km_antes:m.alerta_km_antes||"",
      alerta_dias_antes:m.alerta_dias_antes||"", notif_email:m.notif_email!==false,
      emails_notif:m.emails_notif||[], observacoes:m.observacoes||"",
      itens: itensCarregados })

    // Carregar hodômetro ao vivo
    if (m.ativo_id) {
      try {
        const r = await axios.get(`${API}/posicoes/ao-vivo`)
        const ativoVivo = r.data.find((a:any)=>a.id===m.ativo_id)
        setHodometroAtivo(ativoVivo || ativos.find((a:any)=>a.id===m.ativo_id))
      } catch { setHodometroAtivo(ativos.find((a:any)=>a.id===m.ativo_id)||null) }
    }
    setTab("nova")
  }

  const abrirConcluir = async (m:any) => {
    const hoje = new Date()
    const dataHoje = `${hoje.getFullYear()}-${String(hoje.getMonth()+1).padStart(2,"0")}-${String(hoje.getDate()).padStart(2,"0")}`
    setModalConcluir(m)
    setNfeFile(null)
    setCotacaoFile(null)
    // Preencher KM realizado com hodômetro atual como sugestão
    setFormConcluir((f:any)=>({...f, hodometro_realizado: m.hodometro_atual ? Math.round(parseFloat(m.hodometro_atual)).toString() : ''}))
    // Buscar itens agendados para pré-preencher
    let itensPreenchidos = [{tipo_id:"",descricao:"",quantidade:"1",unidade:"un",custo_unitario:""}]
    try {
      const r = await axios.get(`${API}/manutencoes/${m.id}/itens`)
      if (r.data && r.data.length > 0) {
        itensPreenchidos = r.data.map((it:any) => ({
          tipo_id: it.tipo_id||"",
          descricao: it.descricao||"",
          quantidade: String(it.quantidade||1),
          unidade: it.unidade||"un",
          custo_unitario: ""
        }))
      }
    } catch {}
    setFormConcluir({ data_realizada:dataHoje, fornecedor_id:"", nf_numero:"", observacoes:"",
      itens: itensPreenchidos })
  }

  const confirmarConcluir = async () => {
    if (!modalConcluir) return
    try {
      const r = await axios.put(`${API}/manutencoes/${modalConcluir.id}/concluir`, {
        hodometro_realizado: formConcluir.hodometro_realizado ? parseFloat(formConcluir.hodometro_realizado) : modalConcluir.hodometro_atual||null,
        data_realizada: formConcluir.data_realizada||null,
        fornecedor_id: formConcluir.fornecedor_id||null,
        nf_numero: formConcluir.nf_numero||null,
        observacoes: formConcluir.observacoes||null,
        itens_realizados: formConcluir.itens.filter((it:any)=>it.tipo_id||it.descricao)
      })
      const manutId = modalConcluir.id
      // Upload dos arquivos
      if (nfeFile) {
        const fd = new FormData()
        fd.append('arquivo', nfeFile)
        fd.append('manutencao_id', manutId)
        fd.append('tipo', 'nfe')
        await axios.post(`${API}/upload/anexo`, fd, { headers:{'Content-Type':'multipart/form-data'} })
      }
      if (cotacaoFile) {
        const fd = new FormData()
        fd.append('arquivo', cotacaoFile)
        fd.append('manutencao_id', manutId)
        fd.append('tipo', 'cotacao')
        await axios.post(`${API}/upload/anexo`, fd, { headers:{'Content-Type':'multipart/form-data'} })
      }
      const proxMsg = r.data.proxima_data ? `\nPróxima: ${fmtData(r.data.proxima_data)}` : ""
      alert(`✅ Manutenção concluída!${proxMsg}`)
      setModalConcluir(null)
      setNfeFile(null)
      setCotacaoFile(null)
      await carregar()
    } catch (e:any) { alert(e.response?.data?.erro||"Erro") }
  }

  const salvar = async () => {
    if (!form.ativo_id) return toast('Selecione um veículo', 'warning')
    if (!editandoId && form.itens.every((it:any)=>!it.tipo_id&&!it.descricao)) return toast('Adicione pelo menos um item', 'warning')
    setSalvando(true)
    try {
      if (editandoId) {
        await axios.put(`${API}/manutencoes/${editandoId}`, {
          data_proxima: form.data_proxima||null,
          hodometro_proximo: form.hodometro_proximo ? parseFloat(form.hodometro_proximo) : null,
          intervalo_km: form.intervalo_km ? parseFloat(form.intervalo_km) : null,
          intervalo_dias: form.intervalo_dias ? parseInt(form.intervalo_dias) : null,
          alerta_km_antes: form.alerta_km_antes||null,
          alerta_dias_antes: form.alerta_dias_antes||null,
          observacoes: form.observacoes||null,
          km_alerta_enviado: false,
          itens: form.itens.filter((it:any)=>it.tipo_id||it.descricao)
        })
        setEditandoId(null)
      } else {
        await axios.post(`${API}/manutencoes`, form)
      }
      setTab('lista'); await carregar(); toast('Manutenção salva com sucesso!', 'success')
      setForm({ ativo_id:"", intervalo_km:"", intervalo_dias:"", data_proxima:"", hodometro_proximo:"", alerta_km_antes:"", alerta_dias_antes:"", notif_email:true, emails_notif:[], observacoes:"",
        itens:[{tipo_id:"",descricao:"",quantidade:"1",unidade:"un"}] })
    } catch (e:any) { alert(e.response?.data?.erro||"Erro") }
    finally { setSalvando(false) }
  }

  const abrirAuditoria = async (m: any) => {
    setModalAuditoria(m)
    setCarregandoAuditoria(true)
    try {
      const r = await axios.get(`${API}/manutencoes/${m.id}/auditoria`)
      setAuditoriaItens(r.data)
    } catch { setAuditoriaItens([]) }
    setCarregandoAuditoria(false)
  }
  const cancelar = async (id:string) => {
    if (!window.confirm("Cancelar esta manutenção?")) return
    try { await axios.put(`${API}/manutencoes/${id}`,{status:"cancelada"}); await carregar() } catch {}
  }
  const excluir = async (id:string) => {
    if (!window.confirm("Excluir permanentemente?")) return
    try { await axios.delete(`${API}/manutencoes/${id}`); await carregar() } catch {}
  }
  const addEmail = () => {
    if (!emailExtra.includes("@")) return
    setForm((f:any)=>({...f,emails_notif:[...f.emails_notif,emailExtra]})); setEmailExtra("")
  }

  const filtradas = manutencoes.filter((m:any) => {
    const sc = m.status_calc||m.status
    if (filtro==="pendentes" && sc==="concluida") return false
    if (filtro==="atrasadas" && sc!=="atrasada") return false
    if (filtro==="concluidas" && sc!=="concluida") return false
    if (filtro==="canceladas" && m.status!=="cancelada") return false
    return true
  })

  const ICONE_ARQUIVO: any = {
    pdf:"📄", jpg:"🖼", jpeg:"🖼", png:"🖼", doc:"📝", docx:"📝",
    xls:"📊", xlsx:"📊", default:"📎"
  }
  const iconeArquivo = (nome:string) => {
    const ext = nome.split(".").pop()?.toLowerCase()||"default"
    return ICONE_ARQUIVO[ext]||ICONE_ARQUIVO.default
  }

  const CardResumo = ({label,valor,cor,icone}:any) => (
    <div style={{background:"#1e2f4a",border:"1px solid #2d4166",borderRadius:12,padding:"16px 20px"}}>
      <div style={{fontSize:24,marginBottom:6}}>{icone}</div>
      <div style={{fontSize:22,fontWeight:700,color:cor}}>{valor}</div>
      <div style={{fontSize:12,color:"#64748b"}}>{label}</div>
    </div>
  )

  if (tab === "nova") return (
    <div style={{padding:24,overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
        <button className="btn btn-ghost" onClick={()=>setTab("lista")}>← Voltar</button>
        <h2 style={{fontSize:20,fontWeight:700}}>{editandoId?"✏️ Editar manutenção":"🔧 Nova manutenção programada"}</h2>
      </div>
      <div style={{maxWidth:800}}>
        <div className="card" style={{marginBottom:16}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:14}}>🚗 Veículo e agendamento</h3>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div className="form-group full">
              <label>Veículo *</label>
              <select value={form.ativo_id} onChange={async e=>{
                setForm({...form,ativo_id:e.target.value})
                if (e.target.value) {
                  try {
                    const r = await axios.get(`${API}/posicoes/ao-vivo`)
                    const ativoVivo = r.data.find((a:any)=>a.id===e.target.value)
                    setHodometroAtivo(ativoVivo || ativos.find((a:any)=>a.id===e.target.value))
                  } catch {
                    setHodometroAtivo(ativos.find((a:any)=>a.id===e.target.value))
                  }
                } else {
                  setHodometroAtivo(null)
                }
              }} disabled={!!editandoId}>
                <option value="">— Selecione —</option>
                {ativos.map((a:any)=><option key={a.id} value={a.id}>{a.nome}{a.placa&&` (${a.placa})`}</option>)}
              </select>
            </div>
            {hodometroAtivo && (
              <div className="form-group full">
                <div style={{background:"#0d1b2e",border:"1px solid #0ea5e9",borderRadius:8,padding:"12px 14px"}}>
                  <div style={{fontSize:11,color:"#64748b",marginBottom:8,fontWeight:600}}>📊 Dados do veículo em tempo real</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:8}}>
                    <div style={{background:"#0c2a4a",borderRadius:8,padding:"10px 14px"}}>
                      <div style={{fontSize:10,color:"#475569",marginBottom:4}}>📏 Hodômetro atual</div>
                      <div style={{fontSize:18,fontWeight:700,color:"#0ea5e9"}}>
                        {hodometroAtivo.hodometro_atual && parseFloat(hodometroAtivo.hodometro_atual) > 0
                          ? `${Math.round(parseFloat(hodometroAtivo.hodometro_atual)).toLocaleString("pt-BR")} km`
                          : hodometroAtivo.odometro && parseFloat(hodometroAtivo.odometro) > 0
                          ? `${Math.round(parseFloat(hodometroAtivo.odometro)).toLocaleString("pt-BR")} km`
                          : "—"}
                      </div>
                    </div>
                    <div style={{background:"#0c2a4a",borderRadius:8,padding:"10px 14px"}}>
                      <div style={{fontSize:10,color:"#475569",marginBottom:4}}>⚙️ Hora motor</div>
                      <div style={{fontSize:18,fontWeight:700,color:"#22c55e"}}>
                        {(() => {
                          const hm = parseFloat(hodometroAtivo.hora_motor||0)
                          if (hm <= 0) return "—"
                          const h = Math.floor(hm)
                          const m = Math.floor((hm-h)*60)
                          const s = Math.floor(((hm-h)*60-m)*60)
                          return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`
                        })()}
                      </div>
                    </div>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontSize:10,color:"#334155"}}>
                      {hodometroAtivo.ultima_posicao_hora && (
                        <span>🕐 {new Date(hodometroAtivo.ultima_posicao_hora).toLocaleString("pt-BR")}</span>
                      )}
                    </div>
                    <div style={{display:"flex",gap:6,justifyContent:"flex-end"}}>
                      <div style={{color:"#0ea5e9",cursor:"pointer",fontSize:11}}
                        onClick={async()=>{
                          try {
                            const r = await axios.get(`${API}/ativos/${hodometroAtivo.id}`)
                            setHodometroAtivo(r.data)
                            const idx = ativos.findIndex((a:any)=>a.id===hodometroAtivo.id)
                            if (idx>=0) { const novos=[...ativos]; novos[idx]=r.data; setAtivos(novos) }
                          } catch {}
                        }}>
                        🔄 Atualizar
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="form-group"><label>Data prevista</label><input type="date" value={form.data_proxima} onChange={e=>setForm({...form,data_proxima:e.target.value})} /></div>
            <div className="form-group"><label>Intervalo em dias</label><input type="number" value={form.intervalo_dias} onChange={e=>setForm({...form,intervalo_dias:e.target.value})} placeholder="Ex: 90" /></div>
            <div className="form-group"><label>Intervalo em km</label><input type="number" value={form.intervalo_km} onChange={e=>setForm({...form,intervalo_km:e.target.value})} placeholder="Ex: 5000" /></div>
            <div className="form-group">
              <label>🔔 KM para próxima manutenção</label>
              <input type="number" value={form.hodometro_proximo}
                onChange={e=>setForm({...form,hodometro_proximo:e.target.value})}
                placeholder="Ex: 50000" />
              <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                Sistema enviará email quando hodômetro atingir este valor
              </div>
            </div>
            <div className="form-group full">
              <label>⏰ Alertar quantos dias antes</label>
              <div style={{display:"flex",gap:6,marginBottom:8}}>
                {[1,3,7,15].map(d=>(
                  <button key={d} type="button" onClick={()=>{
                    const dias = form.alerta_dias_antes?form.alerta_dias_antes.split(",").map((x:string)=>x.trim()).filter(Boolean):[]
                    const jatem = dias.includes(String(d))
                    setForm({...form,alerta_dias_antes:(jatem?dias.filter((x:string)=>x!==String(d)):[...dias,String(d)]).join(",")})
                  }} style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",fontFamily:"Inter",fontSize:12,
                    background:form.alerta_dias_antes&&form.alerta_dias_antes.split(",").map((x:string)=>x.trim()).includes(String(d))?"#0ea5e9":"#1a2744",
                    color:form.alerta_dias_antes&&form.alerta_dias_antes.split(",").map((x:string)=>x.trim()).includes(String(d))?"#fff":"#94a3b8",
                    outline:form.alerta_dias_antes&&form.alerta_dias_antes.split(",").map((x:string)=>x.trim()).includes(String(d))?"2px solid #0ea5e9":"1px solid #2d4166"}}>
                    {d} {d===1?"dia":"dias"}
                  </button>
                ))}
              </div>
              <input type="text" value={form.alerta_dias_antes} onChange={e=>setForm({...form,alerta_dias_antes:e.target.value})} placeholder="Personalizado: ex 2,5,10" />
            </div>
            <div className="form-group full">
              <label>📏 Alertar quantos km antes</label>
              <div style={{display:"flex",gap:6,marginBottom:8}}>
                {[100,300,500,1000].map(k=>(
                  <button key={k} type="button" onClick={()=>{
                    const kms = form.alerta_km_antes?form.alerta_km_antes.split(",").map((x:string)=>x.trim()).filter(Boolean):[]
                    const jatem = kms.includes(String(k))
                    setForm({...form,alerta_km_antes:(jatem?kms.filter((x:string)=>x!==String(k)):[...kms,String(k)]).join(",")})
                  }} style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",fontFamily:"Inter",fontSize:12,
                    background:form.alerta_km_antes&&form.alerta_km_antes.split(",").map((x:string)=>x.trim()).includes(String(k))?"#0ea5e9":"#1a2744",
                    color:form.alerta_km_antes&&form.alerta_km_antes.split(",").map((x:string)=>x.trim()).includes(String(k))?"#fff":"#94a3b8",
                    outline:form.alerta_km_antes&&form.alerta_km_antes.split(",").map((x:string)=>x.trim()).includes(String(k))?"2px solid #0ea5e9":"1px solid #2d4166"}}>
                    {k.toLocaleString("pt-BR")} km
                  </button>
                ))}
              </div>
              <input type="text" value={form.alerta_km_antes} onChange={e=>setForm({...form,alerta_km_antes:e.target.value})} placeholder="Personalizado: ex 200,800" />
            </div>
            <div className="form-group full"><label>Observações</label><input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})} placeholder="Opcional" /></div>
          </div>
        </div>

        <div className="card" style={{marginBottom:16}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <h3 style={{fontSize:14,fontWeight:700}}>🔩 Itens de manutenção</h3>
              <button className="btn btn-ghost" style={{fontSize:12}} onClick={addItem}>+ Adicionar item</button>
            </div>
            {/* Tipo de veículo para filtrar peças */}
            <div style={{marginBottom:12,display:"flex",gap:10,alignItems:"center"}}>
              <div style={{flex:1}}>
                <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>🚗 Tipo de veículo (para sugestão de peças)</label>
                <select value={tipoVeiculoSel} onChange={async(e)=>{
                  const tid=e.target.value
                  setTipoVeiculoSel(tid)
                  if(tid){
                    try{
                      const r=await axios.get(`${API}/pecas-manutencao?tipo_ativo_id=${tid}`)
                      setPecasFiltradas(r.data)
                    }catch{setPecasFiltradas([])}
                  } else { setPecasFiltradas([]) }
                }}>
                  <option value="">— Selecione para ver peças —</option>
                  {tiposVeiculo.map((t:any)=><option key={t.id} value={t.id}>{t.nome}</option>)}
                </select>
              </div>
            </div>

            {form.itens.map((item:any,i:number)=>(
              <div key={i} style={{background:"#0d1b2e",borderRadius:8,padding:12,marginBottom:8,border:"1px solid #2d4166"}}>
                <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
                  <div style={{flex:2}}><label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Tipo *</label>
                    <select value={item.peca_id||item.tipo_id} onChange={e=>{
                      const val=e.target.value
                      if(val.startsWith('peca:')){
                        const nomePeca=val.replace('peca:','')
                        updItem(i,"tipo_id","peca")
                        updItem(i,"peca_id",val)
                        updItem(i,"descricao",nomePeca)
                      } else {
                        updItem(i,"tipo_id",val)
                        updItem(i,"peca_id","")
                      }
                    }} style={{marginBottom:0}}>
                      <option value="">— Selecione —</option>
                      {tipos.map((t:any)=><option key={t.id} value={t.id}>{t.icone} {t.nome}</option>)}
                      {pecasFiltradas.length>0 && (
                        <optgroup label={`── Peças ${tiposVeiculo.find((t:any)=>t.id===tipoVeiculoSel)?.nome||''} ──`}>
                          {pecasFiltradas.map((p:any)=>(
                            <option key={p.id} value={`peca:${p.nome}`}>🔩 {p.nome}</option>
                          ))}
                        </optgroup>
                      )}
                    </select>
                  </div>
                  <div style={{flex:2}}><label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Descrição</label>
                    <input value={item.descricao} onChange={e=>updItem(i,"descricao",e.target.value)} placeholder="Ex: Óleo 5W30" style={{marginBottom:0}} />
                  </div>
                  <div style={{flex:1}}><label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Qtd</label>
                    <input type="number" value={item.quantidade} onChange={e=>updItem(i,"quantidade",e.target.value)} style={{marginBottom:0}} min={0} />
                  </div>
                  <div style={{flex:1}}><label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Un</label>
                    <select value={item.unidade} onChange={e=>updItem(i,"unidade",e.target.value)} style={{marginBottom:0}}>
                      {UNIDADES.map(u=><option key={u} value={u}>{u}</option>)}
                    </select>
                  </div>
                  {form.itens.length>1 && <button onClick={()=>remItem(i)} style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"6px 8px",cursor:"pointer"}}>✕</button>}
                </div>
              </div>
            ))}
          </div>

        <div className="card" style={{marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <h3 style={{fontSize:14,fontWeight:700}}>🔔 Notificações por email</h3>
            <div onClick={()=>setForm({...form,notif_email:!form.notif_email})}
              style={{width:44,height:24,borderRadius:12,cursor:"pointer",position:"relative",background:form.notif_email?"#0ea5e9":"#2d4166",transition:"background 0.2s"}}>
              <div style={{position:"absolute",top:3,left:form.notif_email?22:3,width:18,height:18,borderRadius:"50%",background:"white",transition:"left 0.2s"}} />
            </div>
          </div>
          {form.notif_email && (
            <div>
              <div style={{display:"flex",gap:8,marginBottom:8}}>
                <input value={emailExtra} onChange={e=>setEmailExtra(e.target.value)} placeholder="email@exemplo.com" onKeyDown={e=>e.key==="Enter"&&addEmail()} style={{flex:1}} />
                <button className="btn btn-primary" onClick={addEmail}>+ Adicionar</button>
              </div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {form.emails_notif.map((em:string)=>(
                  <div key={em} style={{display:"flex",alignItems:"center",gap:6,background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:20,padding:"4px 10px 4px 12px",fontSize:12}}>
                    <span style={{color:"#38bdf8"}}>{em}</span>
                    <button onClick={()=>setForm((f:any)=>({...f,emails_notif:f.emails_notif.filter((x:string)=>x!==em)}))} style={{background:"none",border:"none",color:"#64748b",cursor:"pointer",fontSize:14}}>✕</button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button className="btn btn-ghost" onClick={()=>setTab("lista")}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvar} disabled={salvando} style={{padding:"12px 32px"}}>
            {salvando?"Salvando...":editandoId?"💾 Salvar alterações":"💾 Agendar manutenção"}
          </button>
        </div>
      </div>
    </div>
  )

  return (
    <div style={{padding:24,overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🔧 Manutenção</h2>
          <p style={{fontSize:13,color:"#64748b"}}>Controle preventivo e corretivo da frota</p>
        </div>
        <button className="btn btn-primary" onClick={()=>setTab("nova")}>+ Nova manutenção</button>
      </div>

      <div style={{display:"flex",gap:0,marginBottom:20,borderBottom:"1px solid #2d4166"}}>
        {[{id:"manutencoes",l:"📋 Manutenções"},{id:"historico",l:`🕐 Histórico (${historico.length})`},{id:"pecas",l:"🔩 Peças"},{id:"fornecedores",l:"🏪 Fornecedores"}].map(a=>(
          <button key={a.id} onClick={()=>setAbaAtiva(a.id as any)}
            style={{padding:"10px 20px",border:"none",background:"transparent",cursor:"pointer",fontFamily:"Inter",
              color:abaAtiva===a.id?"#38bdf8":"#64748b",fontSize:13,
              borderBottom:abaAtiva===a.id?"2px solid #0ea5e9":"2px solid transparent",
              fontWeight:abaAtiva===a.id?600:400}}>
            {a.l}
          </button>
        ))}
      </div>

      {abaAtiva === "manutencoes" && (
        <>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
            <CardResumo label="Total" valor={resumo.total||0} cor="#0ea5e9" icone="📋" />
            <CardResumo label="Pendentes" valor={resumo.pendentes||0} cor="#f59e0b" icone="⏳" />
            <CardResumo label="Atrasadas" valor={resumo.atrasadas||0} cor="#ef4444" icone="⚠️" />
            <CardResumo label="Gasto total" valor={fmt(resumo.gasto_total||0)} cor="#22c55e" icone="💰" />
          </div>
          <div style={{display:"flex",gap:6,marginBottom:16,flexWrap:"wrap"}}>
            {[{id:"todas",l:"Todas"},{id:"pendentes",l:"Pendentes"},{id:"atrasadas",l:"⚠️ Atrasadas"},{id:"concluidas",l:"✅ Concluídas"},{id:"canceladas",l:"🚫 Canceladas"}].map(f=>(
              <button key={f.id} onClick={()=>setFiltro(f.id)}
                style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",fontFamily:"Inter",fontSize:12,
                  background:filtro===f.id?"#0ea5e9":"#1e2f4a",color:filtro===f.id?"#fff":"#94a3b8"}}>
                {f.l}
              </button>
            ))}
          </div>
          {loading ? (
            <div style={{textAlign:"center",color:"#64748b",padding:40}}>Carregando...</div>
          ) : filtradas.length === 0 ? (
            <div className="card" style={{textAlign:"center",padding:48}}>
              <div style={{fontSize:48,marginBottom:12}}>🔧</div>
              <div style={{fontSize:16,fontWeight:600,marginBottom:8}}>Nenhuma manutenção encontrada</div>
              <button className="btn btn-primary" onClick={()=>setTab("nova")} style={{marginTop:8}}>+ Nova manutenção</button>
            </div>
          ) : (
            <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
              <thead>
                <tr style={{borderBottom:"1px solid #2d4166"}}>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Veículo</th>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Tipo</th>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Status</th>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Prazo</th>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Intervalo</th>
                  <th style={{textAlign:"right",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Custo</th>
                  <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Usuário</th>
                  <th style={{textAlign:"right",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Ações</th>
                </tr>
              </thead>
              <tbody>
              {filtradas.map((m:any)=>{
                const sc = m.status_calc||m.status
                const st = STATUS_COR[sc]||STATUS_COR.programada
                return (
                  <tr key={m.id} style={{borderBottom:"1px solid #1e2f4a"}} title={m.observacoes||undefined}>
                    <td style={{padding:"10px 8px"}}>
                      <div style={{fontWeight:600}}>{m.ativo_nome}</div>
                      {m.placa&&<div style={{fontSize:11,color:"#64748b"}}>{m.placa}</div>}
                    </td>
                    <td style={{padding:"10px 8px",color:"#94a3b8"}}>{m.tipo_nome||"Múltiplos itens"}</td>
                    <td style={{padding:"10px 8px"}}>
                      <span style={{fontSize:11,padding:"3px 10px",borderRadius:20,fontWeight:600,background:st.bg,color:st.text,border:`1px solid ${st.border}`,whiteSpace:"nowrap"}}>{st.label}</span>
                    </td>
                    <td style={{padding:"10px 8px"}}>
                      {sc==="concluida" ? (
                        <>
                          {m.data_realizada&&<div style={{color:"#f1f5f9"}}>{fmtData(m.data_realizada)}</div>}
                          {m.hodometro_realizado&&<div style={{fontSize:11,color:"#64748b"}}>realizada em: {Math.round(m.hodometro_realizado).toLocaleString("pt-BR")} km</div>}
                        </>
                      ) : (
                        <>
                          {m.data_proxima&&<div style={{color:sc==="atrasada"?"#ef4444":sc==="proxima"?"#f59e0b":"#f1f5f9"}}>{fmtData(m.data_proxima)}</div>}
                          {(m.km_restantes!==null&&m.km_restantes!==undefined)&&<div style={{color:m.km_restantes<0?"#ef4444":"#94a3b8"}}>{m.km_restantes<0?`${Math.abs(Math.round(m.km_restantes))} km atrasado`:`faltam ${Math.round(m.km_restantes)} km`}</div>}
                          {m.hodometro_atual&&<div style={{fontSize:11,color:"#64748b"}}>hodômetro atual: {Math.round(m.hodometro_atual).toLocaleString("pt-BR")} km</div>}
                        </>
                      )}
                    </td>
                    <td style={{padding:"10px 8px",color:"#94a3b8"}}>{m.intervalo_km?`a cada ${Math.round(m.intervalo_km).toLocaleString("pt-BR")} km`:m.intervalo_dias?`a cada ${m.intervalo_dias} dias`:"—"}</td>
                    <td style={{padding:"10px 8px",textAlign:"right",color:m.custo?"#f1f5f9":"#475569"}}>{m.custo?`R$ ${parseFloat(m.custo).toLocaleString("pt-BR",{minimumFractionDigits:2})}`:"—"}</td>
                    <td style={{padding:"10px 8px"}}>
                      {sc==="concluida" ? (
                        <div style={{color:"#94a3b8"}}>✅ {m.concluido_por_nome||"—"}</div>
                      ) : m.status==="cancelada" ? (
                        <div style={{color:"#94a3b8"}}>🚫 {m.cancelado_por_nome||"—"}</div>
                      ) : (
                        <div style={{color:"#94a3b8"}}>{m.criado_por_nome||"—"}</div>
                      )}
                      {m.gerado_automaticamente && <div style={{fontSize:10,color:"#64748b"}}>gerada automaticamente</div>}
                    </td>
                    <td style={{padding:"10px 8px",textAlign:"right",whiteSpace:"nowrap"}}>
                      <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>abrirAuditoria(m)} title="Historico de edicoes">🕘</button>
                      {sc!=="concluida"&&m.status!=="cancelada" ? (
                        <>
                          <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>abrirConcluir(m)} title="Concluir">✅</button>
                          <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>editarManut(m)} title="Editar">✏️</button>
                          <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>cancelar(m.id)} title="Cancelar">🚫</button>
                          <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>excluir(m.id)} title="Excluir">🗑</button>
                        </>
                      ) : (
                        <button className="btn btn-ghost" style={{fontSize:15,padding:"4px 6px"}} onClick={()=>excluir(m.id)} title="Remover">🗑</button>
                      )}
                    </td>
                  </tr>
                )
              })}
              </tbody>
            </table>
            </div>
          )}
        </>
      )}

      {abaAtiva === "historico" && (
        <div>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            <input value={buscaHistorico} onChange={e=>setBuscaHistorico(e.target.value)}
              placeholder="Buscar por placa, veiculo, marca ou modelo..." style={{flex:1,maxWidth:400}} />
            <select value={ativoFiltro} onChange={e=>setAtivoFiltro(e.target.value)} style={{maxWidth:280}}>
              <option value="">Todos os veículos</option>
              {ativos.map((a:any)=><option key={a.id} value={a.id}>{a.nome}{a.placa&&` (${a.placa})`}</option>)}
            </select>
          </div>
          {(() => {
            const termo = buscaHistorico.trim().toLowerCase()
            const historicoFiltrado = historico.filter((h:any) => {
              if (ativoFiltro && h.ativo_id !== ativoFiltro) return false
              if (!termo) return true
              return [h.ativo_nome, h.placa, h.ativo_marca, h.ativo_modelo, h.ativo_id]
                .filter(Boolean).some((campo:any) => String(campo).toLowerCase().includes(termo))
            })
            if (historicoFiltrado.length === 0) {
              return (
                <div className="card" style={{textAlign:"center",padding:48}}>
                  <div style={{fontSize:48,marginBottom:12}}>🕐</div>
                  <div style={{fontSize:16,fontWeight:600,marginBottom:8}}>{termo?"Nenhum resultado encontrado":"Nenhum histórico ainda"}</div>
                  <div style={{fontSize:13,color:"#64748b"}}>{termo?"Tente outro termo de busca":"As manutenções concluídas aparecerão aqui"}</div>
                </div>
              )
            }
            return (
              <div style={{overflowX:"auto"}}>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
                <thead>
                  <tr style={{borderBottom:"1px solid #2d4166"}}>
                    <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Veículo</th>
                    <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Data</th>
                    <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Fornecedor</th>
                    <th style={{textAlign:"left",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Itens</th>
                    <th style={{textAlign:"right",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>Custo</th>
                    <th style={{textAlign:"right",padding:"10px 8px",color:"#94a3b8",fontWeight:400}}>NF</th>
                  </tr>
                </thead>
                <tbody>
                  {historicoFiltrado.map((h:any) => {
                    const itensValidos = (h.itens||[]).filter((it:any)=>it.tipo_id||it.descricao)
                    const expandido = historicoExpandido === h.id
                    return (
                      <React.Fragment key={h.id}>
                        <tr style={{borderBottom:"1px solid #1e2f4a",cursor:"pointer"}}
                          onClick={()=>setHistoricoExpandido(expandido?null:h.id)}>
                          <td style={{padding:"10px 8px"}}>
                            <div style={{fontWeight:600}}>{h.ativo_nome}</div>
                            {(h.placa||h.ativo_marca)&&<div style={{fontSize:11,color:"#64748b"}}>{[h.placa,h.ativo_marca,h.ativo_modelo].filter(Boolean).join(" · ")}</div>}
                          </td>
                          <td style={{padding:"10px 8px",color:"#94a3b8"}}>{h.data_realizada?fmtData(h.data_realizada):"—"}</td>
                          <td style={{padding:"10px 8px",color:"#94a3b8"}}>{h.fornecedor_nome_rel||h.fornecedor_nome||"—"}</td>
                          <td style={{padding:"10px 8px",color:"#94a3b8"}}>{itensValidos.length>0?`${itensValidos.length} item(ns)`:"—"}</td>
                          <td style={{padding:"10px 8px",textAlign:"right",color:h.custo_total>0?"#22c55e":"#475569",fontWeight:h.custo_total>0?700:400}}>{h.custo_total>0?fmt(h.custo_total):"—"}</td>
                          <td style={{padding:"10px 8px",textAlign:"right",color:"#94a3b8"}}>{h.nf_numero||"—"}</td>
                        </tr>
                        {expandido && (
                          <tr style={{borderBottom:"1px solid #1e2f4a",background:"#0d1b2e"}}>
                            <td colSpan={6} style={{padding:16}}>
                              {itensValidos.length>0 && (
                                <div style={{marginBottom:10}}>
                                  <div style={{fontSize:11,color:"#94a3b8",marginBottom:6,fontWeight:600}}>🔩 Itens realizados:</div>
                                  <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                                    {itensValidos.map((it:any,i:number)=>(
                                      <div key={i} style={{background:"#162035",borderRadius:8,padding:"6px 10px",fontSize:11}}>
                                        <span style={{color:"#f1f5f9"}}>{it.descricao||"Item"}</span>
                                        {it.quantidade&&<span style={{color:"#64748b"}}> · {it.quantidade} {it.unidade||"un"}</span>}
                                        {it.custo_unitario&&<span style={{color:"#22c55e"}}> · {fmt(parseFloat(it.custo_unitario)*parseFloat(it.quantidade||1))}</span>}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {h.observacoes&&<div style={{fontSize:12,color:"#64748b",marginBottom:8}}>📝 {h.observacoes}</div>}
                              {h.anexos && h.anexos.length > 0 && (
                                <div style={{marginBottom:8}}>
                                  <div style={{fontSize:11,color:"#94a3b8",marginBottom:6,fontWeight:600}}>📎 Anexos:</div>
                                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                                    {h.anexos.map((anx:any,i:number)=>(
                                      <a key={i} href={anx.url} target="_blank" rel="noreferrer" onClick={e=>e.stopPropagation()}
                                        style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,
                                          background:"#162035",border:"1px solid #2d4166",borderRadius:8,
                                          padding:"8px 12px",textDecoration:"none",minWidth:80}}>
                                        <span style={{fontSize:24}}>{iconeArquivo(anx.nome_arquivo)}</span>
                                        <span style={{fontSize:10,color:"#94a3b8",textAlign:"center",wordBreak:"break-all",maxWidth:80}}>{anx.nome_arquivo}</span>
                                        <span style={{fontSize:9,color:"#475569"}}>{anx.tipo==="nfe"?"NF-e":"Cotação"}</span>
                                      </a>
                                    ))}
                                  </div>
                                </div>
                              )}
                              <div style={{fontSize:10,color:"#334155"}}>Registrado em {new Date(h.criado_em).toLocaleString("pt-BR")}</div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    )
                  })}
                </tbody>
              </table>
              </div>
            )
          })()}
        </div>
      )}


      {abaAtiva === "pecas" && (
        <div>
          <div className="card" style={{marginBottom:16,padding:16}}>
            <h3 style={{fontSize:14,fontWeight:700,marginBottom:12}}>🔩 {editPeca?"Editar Peça":"Nova Peça"}</h3>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 2fr",gap:12,alignItems:"end"}}>
              <div className="form-group" style={{margin:0}}>
                <label>Nome da peça *</label>
                <input value={formPeca.nome} onChange={e=>setFormPeca({...formPeca,nome:e.target.value})}
                  placeholder="Ex: Óleo Motor" />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Tipos de veículo * (múltipla seleção)</label>
                <div style={{display:"flex",flexWrap:"wrap",gap:4,marginTop:4}}>
                  {tiposVeiculo.map((t:any)=>{
                    const sel=(formPeca.tipos_ativo_ids||[]).includes(t.id)
                    return(
                      <button key={t.id} type="button" onClick={()=>{
                        const ids=formPeca.tipos_ativo_ids||[]
                        setFormPeca({...formPeca,tipos_ativo_ids:sel?ids.filter((x:string)=>x!==t.id):[...ids,t.id]})
                      }} style={{padding:"4px 10px",borderRadius:20,border:"none",cursor:"pointer",
                        fontFamily:"Inter",fontSize:11,
                        background:sel?"#0ea5e9":"#1a2744",
                        color:sel?"#fff":"#94a3b8",
                        outline:sel?"2px solid #0ea5e9":"1px solid #2d4166"}}>
                        {t.nome}
                      </button>
                    )
                  })}
                </div>
                {(formPeca.tipos_ativo_ids||[]).length===0 && <div style={{fontSize:10,color:"#f87171",marginTop:4}}>Selecione ao menos um tipo</div>}
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Descrição</label>
                <input value={formPeca.descricao||''} onChange={e=>setFormPeca({...formPeca,descricao:e.target.value})}
                  placeholder="Opcional" />
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginTop:12}}>
              <button className="btn btn-primary" disabled={salvendoPeca} onClick={async()=>{
                if(!formPeca.nome||!(formPeca.tipos_ativo_ids||[]).length) return alert("Nome e ao menos um tipo são obrigatórios")
                setSalvendoPeca(true)
                try {
                  if(editPeca) await axios.put(`${API}/pecas-manutencao/${editPeca.id}`,formPeca)
                  else await axios.post(`${API}/pecas-manutencao`,formPeca)
                  setFormPeca({nome:'',tipo_ativo_id:'',descricao:''})
                  setEditPeca(null)
                  await carregar()
                } catch(e:any){ toast(e.response?.data?.erro||'Erro ao salvar', 'error') }
                finally { setSalvendoPeca(false) }
              }}>{salvendoPeca?"⏳ Salvando...":editPeca?"💾 Atualizar":"➕ Adicionar"}</button>
              {editPeca && <button className="btn btn-ghost" onClick={()=>{setEditPeca(null);setFormPeca({nome:'',tipo_ativo_id:'',descricao:''})}}>Cancelar</button>}
            </div>
          </div>

          {/* Filtro por tipo */}
          <div style={{marginBottom:12}}>
            <select value={filtroPecaTipo} onChange={e=>setFiltroPecaTipo(e.target.value)} style={{minWidth:200}}>
              <option value="">Todos os tipos</option>
              {tipos.map((t:any)=><option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
          </div>

          <div className="card" style={{padding:0,overflow:"hidden"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:"#0d1b2e"}}>
                  {["Peça","Tipo de Veículo","Descrição","Ações"].map(h=>(
                    <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,color:"#64748b",fontWeight:600}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pecas.filter(p=>!filtroPecaTipo||p.tipo_ativo_id===filtroPecaTipo).length===0?(
                  <tr><td colSpan={4} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhuma peça cadastrada</td></tr>
                ):pecas.filter(p=>!filtroPecaTipo||p.tipo_ativo_id===filtroPecaTipo).map((p:any)=>(
                  <tr key={p.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                    <td style={{padding:"10px 14px",fontSize:13,fontWeight:600}}>🔩 {p.nome}</td>
                    <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>{p.tipo_nome||"Geral"}</td>
                    <td style={{padding:"10px 14px",fontSize:12,color:"#64748b"}}>{p.descricao||"—"}</td>
                    <td style={{padding:"10px 14px"}}>
                      <div style={{display:"flex",gap:4}}>
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}} onClick={()=>{
                          setEditPeca(p); setFormPeca({nome:p.nome,tipos_ativo_ids:p.tipos_ativo_ids||[],descricao:p.descricao||''})
                        }}>✏️</button>
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#f87171"}} onClick={async()=>{
                          const ok = await confirm({mensagem:`Remover "${p.nome}"?`, detalhe:'Esta ação não pode ser desfeita.', tipo:'danger', labelConfirm:'Remover'})
                          if(!ok) return
                          await axios.delete(`${API}/pecas-manutencao/${p.id}`)
                          toast('Peça removida com sucesso!', 'success')
                          await carregar()
                        }}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {abaAtiva === "fornecedores" && (
        <div>
          <div className="card" style={{marginBottom:16,padding:16}}>
            <h3 style={{fontSize:14,fontWeight:700,marginBottom:12}}>🏪 {editForn?"Editar Fornecedor":"Novo Fornecedor"}</h3>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
              {/* CNPJ com consulta */}
              <div className="form-group" style={{margin:0}}>
                <label>CNPJ/CPF</label>
                <div style={{display:"flex",gap:6}}>
                  <input value={formForn.cnpj||''} onChange={e=>setFormForn({...formForn,cnpj:e.target.value})}
                    placeholder="00.000.000/0000-00" style={{flex:1}} />
                  <button type="button" className="btn btn-ghost" style={{fontSize:11,whiteSpace:"nowrap"}}
                    disabled={consultandoCNPJ||!formForn.cnpj}
                    onClick={async()=>{
                      const cnpj=(formForn.cnpj||'').replace(/\D/g,'')
                      if(cnpj.length!==14) return alert("CNPJ deve ter 14 dígitos")
                      setConsultandoCNPJ(true)
                      try {
                        const r=await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`)
                        setFormForn({...formForn,
                          nome:r.data.razao_social||formForn.nome,
                          nome_fantasia:r.data.nome_fantasia||'',
                          cep:r.data.cep||'',
                          logradouro:r.data.logradouro||'',
                          numero:r.data.numero||'',
                          bairro:r.data.bairro||'',
                          cidade:r.data.municipio||'',
                          estado:r.data.uf||'',
                          telefone:r.data.ddd_telefone_1?r.data.ddd_telefone_1.replace(/\D/g,''):formForn.telefone,
                          email:r.data.email||formForn.email
                        })
                      } catch { alert("CNPJ não encontrado") }
                      finally { setConsultandoCNPJ(false) }
                    }}>
                    {consultandoCNPJ?"⏳":"🔍"}
                  </button>
                </div>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Tipo</label>
                <select value={formForn.tipo} onChange={e=>setFormForn({...formForn,tipo:e.target.value})}>
                  <option value="oficina">🔧 Oficina</option>
                  <option value="pecas">🔩 Peças</option>
                  <option value="combustivel">⛽ Combustível</option>
                  <option value="outros">📦 Outros</option>
                </select>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Razão Social *</label>
                <input value={formForn.nome} onChange={e=>setFormForn({...formForn,nome:e.target.value})} placeholder="Razão Social" />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Nome Fantasia</label>
                <input value={formForn.nome_fantasia||''} onChange={e=>setFormForn({...formForn,nome_fantasia:e.target.value})} placeholder="Nome Fantasia" />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Telefone</label>
                <input value={formForn.telefone||''} onChange={e=>setFormForn({...formForn,telefone:e.target.value})} placeholder="(00) 00000-0000" />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>E-mail</label>
                <input value={formForn.email||''} onChange={e=>setFormForn({...formForn,email:e.target.value})} placeholder="email@fornecedor.com" />
              </div>
              {/* CEP com consulta */}
              <div className="form-group" style={{margin:0}}>
                <label>CEP</label>
                <div style={{display:"flex",gap:6}}>
                  <input value={formForn.cep||''} onChange={e=>setFormForn({...formForn,cep:e.target.value})}
                    placeholder="00000-000" style={{flex:1}} />
                  <button type="button" className="btn btn-ghost" style={{fontSize:11}}
                    disabled={consultandoCEP||!formForn.cep}
                    onClick={async()=>{
                      const cep=(formForn.cep||'').replace(/\D/g,'')
                      if(cep.length!==8) return alert("CEP deve ter 8 dígitos")
                      setConsultandoCEP(true)
                      try {
                        const r=await axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`)
                        setFormForn({...formForn,
                          logradouro:r.data.street||'',
                          bairro:r.data.neighborhood||'',
                          cidade:r.data.city||'',
                          estado:r.data.state||''
                        })
                      } catch { alert("CEP não encontrado") }
                      finally { setConsultandoCEP(false) }
                    }}>
                    {consultandoCEP?"⏳":"🔍"}
                  </button>
                </div>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Logradouro</label>
                <div style={{display:"flex",gap:6}}>
                  <input value={formForn.logradouro||''} onChange={e=>setFormForn({...formForn,logradouro:e.target.value})} placeholder="Rua/Av" style={{flex:1}} />
                  <input value={formForn.numero||''} onChange={e=>setFormForn({...formForn,numero:e.target.value})} placeholder="Nº" style={{width:60}} />
                </div>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Bairro / Cidade / UF</label>
                <div style={{display:"flex",gap:6}}>
                  <input value={formForn.bairro||''} onChange={e=>setFormForn({...formForn,bairro:e.target.value})} placeholder="Bairro" style={{flex:1}} />
                  <input value={formForn.cidade||''} onChange={e=>setFormForn({...formForn,cidade:e.target.value})} placeholder="Cidade" style={{flex:1}} />
                  <input value={formForn.estado||''} onChange={e=>setFormForn({...formForn,estado:e.target.value})} placeholder="UF" style={{width:44}} maxLength={2} />
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,marginTop:12}}>
              <button className="btn btn-primary" disabled={salvendoForn} onClick={async()=>{
                if(!formForn.nome) return alert("Nome é obrigatório")
                setSalvendoForn(true)
                try {
                  if(editForn) await axios.put(`${API}/fornecedores/${editForn.id}`,formForn)
                  else await axios.post(`${API}/fornecedores`,formForn)
                  setFormForn({nome:'',telefone:'',email:'',cnpj:'',cidade:'',estado:'',tipo:'oficina'})
                  setEditForn(null)
                  await carregar()
                } catch(e:any){ toast(e.response?.data?.erro||'Erro ao salvar', 'error') }
                finally { setSalvendoForn(false) }
              }}>{salvendoForn?"⏳ Salvando...":editForn?"💾 Atualizar":"➕ Adicionar"}</button>
              {editForn && <button className="btn btn-ghost" onClick={()=>{setEditForn(null);setFormForn({nome:'',telefone:'',email:'',cnpj:'',cidade:'',estado:'',tipo:'oficina'})}}>Cancelar</button>}
            </div>
          </div>

          <div className="card" style={{padding:0,overflow:"hidden"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr style={{background:"#0d1b2e"}}>
                  {["Nome","Tipo","Contato","Cidade/UF","Ações"].map(h=>(
                    <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,color:"#64748b",fontWeight:600}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {fornecedores.length===0?(
                  <tr><td colSpan={5} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum fornecedor cadastrado</td></tr>
                ):fornecedores.map((f:any)=>(
                  <tr key={f.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                    <td style={{padding:"10px 14px",fontSize:13,fontWeight:600}}>{f.nome}</td>
                    <td style={{padding:"10px 14px",fontSize:12}}>
                      <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,
                        background:f.tipo==='oficina'?"#1e3a6e":f.tipo==='pecas'?"#1a2744":f.tipo==='combustivel'?"#451a03":"#1e293b",
                        color:f.tipo==='oficina'?"#38bdf8":f.tipo==='pecas'?"#94a3b8":f.tipo==='combustivel'?"#fbbf24":"#64748b"}}>
                        {f.tipo==='oficina'?"🔧 Oficina":f.tipo==='pecas'?"🔩 Peças":f.tipo==='combustivel'?"⛽ Combustível":"📦 Outros"}
                      </span>
                    </td>
                    <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>
                      {f.telefone&&<div>{f.telefone}</div>}
                      {f.email&&<div style={{fontSize:11}}>{f.email}</div>}
                    </td>
                    <td style={{padding:"10px 14px",fontSize:12,color:"#64748b"}}>{f.cidade&&`${f.cidade}${f.estado?' - '+f.estado:''}`||"—"}</td>
                    <td style={{padding:"10px 14px"}}>
                      <div style={{display:"flex",gap:4}}>
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}} onClick={()=>{
                          setEditForn(f); setFormForn({nome:f.nome,telefone:f.telefone||'',email:f.email||'',cnpj:f.cnpj||'',cidade:f.cidade||'',estado:f.estado||'',tipo:f.tipo||'oficina'})
                        }}>✏️</button>
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#f87171"}} onClick={async()=>{
                          if(!window.confirm(`Remover "${f.nome}"?`)) return
                          await axios.delete(`${API}/fornecedores/${f.id}`)
                          await carregar()
                        }}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modalConcluir && (
        <div className="modal-overlay" onClick={()=>setModalConcluir(null)}>
          <div className="modal" style={{width:600,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>✅ Registrar conclusão</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalConcluir(null)}>✕</button>
            </div>
            <div style={{background:"#0d1b2e",borderRadius:8,padding:12,marginBottom:16}}>
              <div style={{fontWeight:700}}>{modalConcluir.ativo_nome}{modalConcluir.placa&&` · ${modalConcluir.placa}`}</div>
              <div style={{fontSize:12,color:"#64748b"}}>{modalConcluir.tipo_nome||"Múltiplos itens"}</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
              <div className="form-group">
                <label>Data de realização</label>
                <input type="date" value={formConcluir.data_realizada} onChange={e=>setFormConcluir({...formConcluir,data_realizada:e.target.value})} />
              </div>
              <div className="form-group">
                <label>Nº NF / Recibo</label>
                <input value={formConcluir.nf_numero} onChange={e=>setFormConcluir({...formConcluir,nf_numero:e.target.value})} placeholder="Opcional" />
              </div>
              <div className="form-group">
                <label>📏 KM realizado</label>
                <input type="number" value={formConcluir.hodometro_realizado||''} 
                  onChange={e=>setFormConcluir({...formConcluir,hodometro_realizado:e.target.value})}
                  placeholder={`Atual: ${modalConcluir.hodometro_atual?Math.round(parseFloat(modalConcluir.hodometro_atual)).toLocaleString('pt-BR')+' km':'—'}`} />
                <div style={{fontSize:10,color:"#475569",marginTop:2}}>
                  Hodômetro no momento da manutenção
                </div>
              </div>
              <div className="form-group full">
                <label>Fornecedor</label>
                <select value={formConcluir.fornecedor_id} onChange={e=>setFormConcluir({...formConcluir,fornecedor_id:e.target.value})}>
                  <option value="">— Selecione —</option>
                  {fornecedores.map((f:any)=><option key={f.id} value={f.id}>{f.nome}{f.cidade&&` · ${f.cidade}`}</option>)}
                </select>
              </div>
            </div>
            <div style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <label style={{fontSize:13,fontWeight:600,color:"#94a3b8",display:"block",marginBottom:0}}>🔩 Itens realizados</label>
                <button className="btn btn-ghost" style={{fontSize:12}} onClick={addItemC}>+ Adicionar item</button>
              </div>
              {formConcluir.itens.map((item:any,i:number)=>(
                <div key={i} style={{background:"#0d1b2e",borderRadius:8,padding:12,marginBottom:8,border:"1px solid #2d4166"}}>
                  <div style={{display:"flex",gap:8,alignItems:"flex-end",flexWrap:"wrap"}}>
                    <div style={{flex:2,minWidth:120}}>
                      <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Tipo</label>
                      <select value={item.tipo_id} onChange={e=>updItemC(i,"tipo_id",e.target.value)} style={{marginBottom:0}}>
                        <option value="">— Selecione —</option>
                        {tipos.map((t:any)=><option key={t.id} value={t.id}>{t.icone} {t.nome}</option>)}
                      </select>
                    </div>
                    <div style={{flex:2,minWidth:100}}>
                      <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Descrição</label>
                      <input value={item.descricao} onChange={e=>updItemC(i,"descricao",e.target.value)} placeholder="Ex: Óleo 5W30" style={{marginBottom:0}} />
                    </div>
                    <div style={{flex:1,minWidth:60}}>
                      <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Qtd</label>
                      <input type="number" value={item.quantidade} onChange={e=>updItemC(i,"quantidade",e.target.value)} style={{marginBottom:0}} min={0} />
                    </div>
                    <div style={{flex:1,minWidth:60}}>
                      <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Un</label>
                      <select value={item.unidade} onChange={e=>updItemC(i,"unidade",e.target.value)} style={{marginBottom:0}}>
                        {UNIDADES.map(u=><option key={u} value={u}>{u}</option>)}
                      </select>
                    </div>
                    <div style={{flex:1,minWidth:70}}>
                      <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>R$ unit.</label>
                      <input type="number" value={item.custo_unitario} onChange={e=>updItemC(i,"custo_unitario",e.target.value)} placeholder="0,00" style={{marginBottom:0}} step={0.01} />
                    </div>
                    {formConcluir.itens.length>1&&<button onClick={()=>remItemC(i)} style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"6px 8px",cursor:"pointer"}}>✕</button>}
                  </div>
                  {item.custo_unitario&&item.quantidade&&(
                    <div style={{fontSize:11,color:"#22c55e",marginTop:6,textAlign:"right"}}>
                      Subtotal: {fmt(parseFloat(item.custo_unitario)*parseFloat(item.quantidade))}
                    </div>
                  )}
                </div>
              ))}
              {formConcluir.itens.some((it:any)=>it.custo_unitario&&it.quantidade)&&(
                <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:8,padding:"10px 14px",textAlign:"right",marginTop:8}}>
                  <span style={{fontSize:13,color:"#94a3b8"}}>Total: </span>
                  <span style={{fontSize:16,fontWeight:700,color:"#22c55e"}}>
                    {fmt(formConcluir.itens.reduce((acc:number,it:any)=>acc+(parseFloat(it.custo_unitario||0)*parseFloat(it.quantidade||0)),0))}
                  </span>
                </div>
              )}
            </div>
            <div style={{display:"flex",gap:12,marginBottom:16}}>
              <div style={{flex:1}}>
                <div style={{background:"#0d1b2e",border:`2px dashed ${nfeFile?"#22c55e":"#2d4166"}`,borderRadius:8,padding:16,textAlign:"center",cursor:"pointer"}}
                  onClick={()=>document.getElementById("nfe")?.click()}>
                  <div style={{fontSize:32}}>{nfeFile ? iconeArquivo(nfeFile.name) : "📄"}</div>
                  {nfeFile ? (
                    <>
                      <div style={{fontSize:11,color:"#22c55e",marginTop:4,fontWeight:600}}>✓ Arquivo anexado</div>
                      <div style={{fontSize:10,color:"#94a3b8",marginTop:2,wordBreak:"break-all"}}>{nfeFile.name}</div>
                      <div style={{fontSize:9,color:"#475569"}}>{(nfeFile.size/1024).toFixed(1)} KB</div>
                    </>
                  ) : (
                    <>
                      <div style={{fontSize:12,color:"#64748b",marginTop:4,fontWeight:600}}>Anexar NF-e / Recibo</div>
                      <div style={{fontSize:10,color:"#475569"}}>PDF, JPG, PNG, Excel</div>
                    </>
                  )}
                  <input id="nfe" type="file" style={{display:"none"}} accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls"
                    onChange={e=>{ if(e.target.files?.[0]) setNfeFile(e.target.files[0]) }} />
                </div>
                {nfeFile && (
                  <button onClick={()=>setNfeFile(null)}
                    style={{width:"100%",marginTop:4,background:"none",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"3px 0",cursor:"pointer",fontSize:11,fontFamily:"Inter"}}>
                    ✕ Remover arquivo
                  </button>
                )}
              </div>
              <div style={{flex:1}}>
                <div style={{background:"#0d1b2e",border:`2px dashed ${cotacaoFile?"#22c55e":"#2d4166"}`,borderRadius:8,padding:16,textAlign:"center",cursor:"pointer"}}
                  onClick={()=>document.getElementById("cotacao")?.click()}>
                  <div style={{fontSize:32}}>{cotacaoFile ? iconeArquivo(cotacaoFile.name) : "📋"}</div>
                  {cotacaoFile ? (
                    <>
                      <div style={{fontSize:11,color:"#22c55e",marginTop:4,fontWeight:600}}>✓ Arquivo anexado</div>
                      <div style={{fontSize:10,color:"#94a3b8",marginTop:2,wordBreak:"break-all"}}>{cotacaoFile.name}</div>
                      <div style={{fontSize:9,color:"#475569"}}>{(cotacaoFile.size/1024).toFixed(1)} KB</div>
                    </>
                  ) : (
                    <>
                      <div style={{fontSize:12,color:"#64748b",marginTop:4,fontWeight:600}}>Anexar Cotação</div>
                      <div style={{fontSize:10,color:"#475569"}}>PDF, JPG, PNG, Excel</div>
                    </>
                  )}
                  <input id="cotacao" type="file" style={{display:"none"}} accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls"
                    onChange={e=>{ if(e.target.files?.[0]) setCotacaoFile(e.target.files[0]) }} />
                </div>
                {cotacaoFile && (
                  <button onClick={()=>setCotacaoFile(null)}
                    style={{width:"100%",marginTop:4,background:"none",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"3px 0",cursor:"pointer",fontSize:11,fontFamily:"Inter"}}>
                    ✕ Remover arquivo
                  </button>
                )}
              </div>
            </div>
            <div className="form-group" style={{marginBottom:16}}>
              <label>Observações</label>
              <input value={formConcluir.observacoes} onChange={e=>setFormConcluir({...formConcluir,observacoes:e.target.value})} placeholder="Opcional" />
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-ghost" onClick={()=>setModalConcluir(null)}>Cancelar</button>
              <button className="btn btn-success" onClick={confirmarConcluir} style={{padding:"10px 24px"}}>✅ Confirmar conclusão</button>
            </div>
          </div>
        </div>
      )}
      {modalAuditoria && (
        <div className="modal-overlay" onClick={()=>setModalAuditoria(null)}>
          <div className="modal" style={{width:520,maxHeight:"80vh",overflow:"auto"}} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>🕘 Historico de edicoes</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalAuditoria(null)}>✕</button>
            </div>
            <div style={{fontSize:12,color:"#64748b",marginBottom:16}}>
              {modalAuditoria.ativo_nome}{modalAuditoria.placa&&` · ${modalAuditoria.placa}`}
            </div>
            {carregandoAuditoria ? (
              <div style={{textAlign:"center",color:"#64748b",padding:24}}>Carregando...</div>
            ) : auditoriaItens.length === 0 ? (
              <div style={{textAlign:"center",color:"#64748b",padding:24}}>Nenhuma edicao registrada ainda.</div>
            ) : (
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {auditoriaItens.map((a:any)=>{
                  const detalhes = a.detalhes||{}
                  const antes = detalhes.antes||{}
                  const depois = detalhes.depois||{}
                  const NOMES_CAMPO: Record<string,string> = {
                    intervalo_km:"Intervalo (km)", intervalo_dias:"Intervalo (dias)",
                    alerta_km_antes:"Avisar antes (km)", alerta_dias_antes:"Avisar antes (dias)",
                    hodometro_proximo:"Hodometro alvo", data_proxima:"Data prevista",
                    tipo_personalizado:"Tipo", descricao:"Descricao", observacoes:"Observacoes",
                    custo:"Custo", fornecedor:"Fornecedor", nf_numero:"NF", status:"Status",
                    ativo_id:"Veiculo", notif_email:"Notificar e-mail", notif_push:"Notificar push",
                    emails_notif:"E-mails", itens:"Itens da manutencao",
                  }
                  const formatarValor = (campo:string, valor:any) => {
                    if (valor===undefined || valor===null || valor==='') return "vazio"
                    if (campo==="itens") return Array.isArray(valor) ? `${valor.length} item(ns)` : "—"
                    if (campo==="emails_notif") return Array.isArray(valor) ? valor.join(", ") : String(valor)
                    if (campo==="status") return valor==="cancelada"?"Cancelada":valor==="concluida"?"Concluida":"Ativa"
                    if (campo==="notif_email"||campo==="notif_push") return valor?"Sim":"Nao"
                    if (typeof valor==="object") return JSON.stringify(valor)
                    return String(valor)
                  }
                  const camposMudados = Object.keys(depois).filter((k:string) =>
                    k!=="itens" && depois[k]!==undefined && depois[k]!==null && depois[k]!=='' &&
                    String(antes[k]??'') !== String(depois[k])
                  )
                  const itensAntes: any[] = Array.isArray(antes.itens) ? antes.itens : []
                  const itensDepois: any[] = Array.isArray(depois.itens) ? depois.itens : []
                  const itensMudaram = JSON.stringify(itensAntes.map((i:any)=>[i.descricao,i.quantidade,i.unidade]).sort())
                    !== JSON.stringify(itensDepois.map((i:any)=>[i.descricao,i.quantidade,i.unidade]).sort())
                  const nomeItem = (it:any) => it.nome || it.descricao || "Item sem nome"
                  const chaveItem = (it:any) => (nomeItem(it)).toLowerCase().trim()
                  const mapaAntes = new Map(itensAntes.map((it:any) => [chaveItem(it), it]))
                  const mapaDepois = new Map(itensDepois.map((it:any) => [chaveItem(it), it]))
                  const itensAdicionados = itensDepois.filter((it:any) => !mapaAntes.has(chaveItem(it)))
                  const itensRemovidos = itensAntes.filter((it:any) => !mapaDepois.has(chaveItem(it)))
                  const itensAlterados = itensDepois.filter((it:any) => {
                    const anterior = mapaAntes.get(chaveItem(it))
                    return anterior && String(anterior.quantidade)!==String(it.quantidade)
                  })
                  return (
                    <div key={a.id} style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,padding:12}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                        <span style={{fontSize:13,fontWeight:600}}>{a.acao}</span>
                        <span style={{fontSize:11,color:"#64748b"}}>{new Date(a.criado_em).toLocaleString("pt-BR")}</span>
                      </div>
                      <div style={{fontSize:12,color:"#94a3b8",marginBottom:(camposMudados.length||itensMudaram)?8:0}}>Por: {a.usuario_nome||"Usuario"}</div>
                      {camposMudados.length > 0 && (
                        <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:itensMudaram?6:0}}>
                          {camposMudados.map((campo:string) => (
                            <div key={campo} style={{fontSize:11,background:"#162035",borderRadius:6,padding:"6px 8px"}}>
                              <div style={{color:"#64748b",marginBottom:2}}>{NOMES_CAMPO[campo]||campo}</div>
                              <div style={{display:"flex",alignItems:"center",gap:6}}>
                                <span style={{color:"#f87171",textDecoration:"line-through"}}>{formatarValor(campo,antes[campo])}</span>
                                <span style={{color:"#475569"}}>→</span>
                                <span style={{color:"#4ade80",fontWeight:600}}>{formatarValor(campo,depois[campo])}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {itensMudaram && (
                        <div style={{fontSize:11,background:"#162035",borderRadius:6,padding:"6px 8px"}}>
                          <div style={{color:"#64748b",marginBottom:4}}>Pecas / itens</div>
                          {itensAdicionados.map((it:any,i:number) => (
                            <div key={`add${i}`} style={{color:"#4ade80"}}>+ Adicionado: {nomeItem(it)} · {it.quantidade} {it.unidade||"un"}</div>
                          ))}
                          {itensRemovidos.map((it:any,i:number) => (
                            <div key={`rem${i}`} style={{color:"#f87171",textDecoration:"line-through"}}>− Removido: {nomeItem(it)} · {it.quantidade} {it.unidade||"un"}</div>
                          ))}
                          {itensAlterados.map((it:any,i:number) => {
                            const anterior = mapaAntes.get(chaveItem(it))
                            return (
                              <div key={`alt${i}`} style={{color:"#fbbf24"}}>
                                Quantidade de {nomeItem(it)}: {anterior?.quantidade} → {it.quantidade} {it.unidade||"un"}
                              </div>
                            )
                          })}
                          {itensAdicionados.length===0 && itensRemovidos.length===0 && itensAlterados.length===0 && (
                            <div style={{color:"#64748b"}}>Lista de itens atualizada</div>
                          )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
